import RandomId from "../../../../src/mdx/api/endpoints/random-id.mdx";
import * as React from 'react';
export default {
  RandomId,
  React
};